import { useId, useRef } from 'react';
import { Modal } from '@/components/Modal';
import { PrivacyDocument } from './PrivacyDocument';

export function PrivacyModal({ open, onClose }) {
  const titleRef = useRef(null);
  const titleId = useId();

  return (
    <Modal
      open={open}
      onClose={onClose}
      initialFocusRef={titleRef}
      className="doc-modal"
      aria-labelledby={titleId}
    >
      <div className="doc-modal-body">
        <div className="modal-head">
          <img
            src="/assets/icons/feature-rbac.png"
            alt=""
            aria-hidden="true"
            width="176"
            height="176"
            className="h-9 w-9"
          />
          <button
            type="button"
            data-modal-close
            aria-label="닫기"
            className="modal-close"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        {/* tabindex=-1 + Modal 의 initialFocusRef: showModal() 이 기본으로 첫 포커스
            가능 요소(닫기 X)에 포커스를 넣는 걸 막고 제목부터 읽히게 한다 */}
        <h2 id={titleId} ref={titleRef} className="doc-modal-title" tabIndex={-1}>
          개인정보 수집 및 이용에 대한 안내
        </h2>

        <PrivacyDocument />
      </div>
    </Modal>
  );
}
